fragment downloads on download_Entry {
  label
  download {
    url
  }
}
